module.exports = __webpack_public_path__ + "img/greenline-green-logo.89ec1b5.png";